import type { BaseUser, User } from '~/modules/users/model'

export const convertToBaseUser = (user: User | undefined): BaseUser => ({
  name: {
    firstName: user?.name?.firstName ?? '',
    lastName: user?.name?.lastName ?? '',
  },
  email: {
    address: user?.email ?? '',
  },
})
